import { useMemo } from 'react';
import { Header, Page } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { TechDocsReaderPageProvider } from '@backstage/plugin-techdocs-react';
import { TechDocsReaderPageContent } from '@backstage/plugin-techdocs';
import { CompoundEntityRef } from '@backstage/catalog-model';
import { TechDocsWrapper } from '../techdocs/TechDocsWrapper';

/**
 * FlowHub page that renders TechDocs content at /flowhub.
 *
 * Reads `app.flowhubComponentId` from config to resolve the target
 * component entity. The value is the fusion-util component ID (SHA-40),
 * which may differ per environment.
 */
export const FlowHubPage = () => {
  const configApi = useApi(configApiRef);
  const componentId = configApi.getOptionalString('app.flowhubComponentId');

  const entityRef: CompoundEntityRef = useMemo(
    () => ({
      kind: 'component',
      namespace: 'default',
      name: componentId ?? '',
    }),
    [componentId],
  );

  if (!componentId) {
    return (
      <Page themeId="documentation">
        <Header title="FLOW Hub" subtitle="FLOW Hub Documentation" />
      </Page>
    );
  }

  return (
    <TechDocsWrapper>
      <TechDocsReaderPageProvider entityRef={entityRef}>
        <Page themeId="documentation">
          <Header title="FLOW Hub" subtitle="FLOW Hub Documentation" />
          <TechDocsReaderPageContent withSearch={false} />
        </Page>
      </TechDocsReaderPageProvider>
    </TechDocsWrapper>
  );
};
